import { lazy } from 'react';
import { useParams } from 'react-router';
import { useOrganisationServicePublic } from 'src/apis/organisation-service/use-organisation-service-public';
import { usePublicOperatorDetails } from 'src/apis/organisation-service/use-public-operator-details';
import { useEligibleSurrenderInquiryDeals } from 'src/apis/surrender-service/use-eligible-surrender-inquiry-deals';
import { useNetworkPointSurrenderSettings } from 'src/apis/surrender-service/use-network-point-surrender-settings';
import { useSurrenderRoot } from 'src/apis/surrender-service/use-surrender-root';
import { PageSpinner } from 'src/components/spinner-container';
import { Forbidden } from 'src/utils/errors';

const Page = lazy(() => import('./page'));

export const CreateSurrenderRequest = () => {
  const surrenderRoot = useSurrenderRoot();
  const { networkPointId } = useParams<{ networkPointId?: string }>();
  const surrenderSettings = useNetworkPointSurrenderSettings({
    surrenderRoot,
    networkPointId,
  });
  const eligibleDeals = useEligibleSurrenderInquiryDeals({
    surrenderRoot,
    params: networkPointId ? { networkPointId } : undefined,
  });
  const organisationServicePublic = useOrganisationServicePublic();
  const tsoId = surrenderSettings?.response?.data.tsoId;
  // TODO: Replace with tsoLogo link from NWP settings endpoint with details page implementation
  const operatorDetails = usePublicOperatorDetails({
    organisationServicePublic,
    operatorUuid: tsoId,
  });

  if (!surrenderRoot.response) return <PageSpinner />;
  if (
    !networkPointId ||
    !surrenderRoot.response.data._links.isSurrenderForAllEnabled
  )
    throw new Forbidden();
  if (
    !surrenderSettings?.response ||
    !eligibleDeals?.response ||
    (tsoId &&
      (!organisationServicePublic.response || !operatorDetails.response))
  )
    return <PageSpinner />;

  return (
    <Page
      networkPointId={networkPointId}
      surrenderRoot={surrenderRoot}
      surrenderSettings={surrenderSettings}
      eligibleDeals={eligibleDeals}
      operatorDetails={operatorDetails.response ? operatorDetails : undefined}
    />
  );
};
